import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
//import { NgwWowService } from 'ngx-wow';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import configura from '../../../assets/config.json';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { MemoryStorageService } from 'src/app/services/memory-storage.service';
interface FoodNodeFlat {
  name: string;
  Id: Number;
  parentId: Number;
  children?: FoodNodeFlat[];
}

interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {


  private _transformer = (node: FoodNodeFlat, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      Id: node.Id
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this._transformer, node => node.level, node => node.expandable, node => node.children);

  groupProjectDataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  subGroupDataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  @ViewChild('groupProjectTree') groupProjectTree;
  @ViewChild('subGroupTree') subGroupTree;

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  max_ideaDataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  @ViewChild('max_ideaTree') max_ideaTree;


  private masterData = [];
  roleList: any = [];
  hasProjectHierarchy: boolean = true;
  isPageLoadCompleted: boolean = false;
  constructor(public _commonService: CommonService,
    private router: Router, private authService: AuthService, private dataService: DataService, private encryptDecryptservice: EncryptDecryptService, private memorystore: MemoryStorageService) {
    //wowService.init();
  }
  grand_total: number = 0;
  max_idea_generated_by_user_count: number = 0;
  max_idead_generated_by_documenttype: number = 0;
  total_idea_for_month: number = 0;
  winning_idea: string = '';
  max_idea_generated_by_user: string = '';
  max_idea_generated_by_document_type_name: string = '';
  ideathon_winnerfor_month: string = '';

  max_idealist: any = [];
  parent_masterData: any = [];
  project_masterData: any = [];
  project_name: string = '';
  role_name: string = '';
  exitingRole_id: any;
  existing_role_name: any;
  // selected_role_id = this._commonService.getUserInfoFromLocalStorage('roleId');
  ngOnInit(): void {
    //this.getAuthorizedData();
    this.getAuthorizedData_new_design()
    this.isPageLoadCompleted = false;
    if (configura.is_Display_maxPIideageneratedByUser == "TRUE") {
      this.maxideageneratedbyUser();
    }
    // this.exitingRole_id = this._commonService.getUserInfoFromLocalStorage('roleId');
    // this.existing_role_name = this._commonService.getUserInfoFromLocalStorage('roleName');
    this.exitingRole_id = this.memorystore.getItem('roleId');
    this.existing_role_name = this.memorystore.getItem('roleName');
  }


  maxideageneratedbyUser() {

    this.max_idealist = [];

    let params = new HttpParams();
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this._commonService.selectedProject));
    params = params.append('subgroup_id', this._commonService.selectedSubgroup);
    params = params.append('role_id', this._commonService.selectedRole);
    // params = params.append('userId', this._commonService.getUserInfoFromLocalStorage('userId'));
    // params = params.append('userId', this.memorystore.getItem('userId'));
    params = params.append('userId', this.memorystore.getItem('userId'));
    // params = params.append('userId', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    // params = params.append('userId',this._commonService.getuserdatacookiedata('encuserId'));
    //Changed get to post
    let bodydata = {
      // roleid: this.encryptDecryptservice.encryptUsingAES256(this._commonService.selectedRole),
      // subgroup_id: this.encryptDecryptservice.encryptUsingAES256(this._commonService.selectedSubgroup),
      projectid: this.encryptDecryptservice.encryptUsingAES256(this._commonService.selectedProject),
      // encuserid: this.encryptDecryptservice.encryptUsingAES256(this._commonService.getUserInfoFromLocalStorage('userId'))
      // encuserid: this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
      encuserid: this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')),
      xusrid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    };
    // this.dataService.getDataPromise('maxideageneratedbyUser', params).then(res => {
    this.dataService.postData('maxideageneratedbyUser', bodydata).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.data != null) {
          // this.grand_total =res.data[0].grand_total;
          // this.max_idea_generated_by_user_count =res.data[0].max_idea_generated_by_user_count;
          // this.max_idead_generated_by_documenttype =res.data[0].max_idead_generated_by_documenttype;
          // this.total_idea_for_month =res.data[0].total_idea_for_month;
          // this.winning_idea = res.data[0].winning_idea;
          // this.max_idea_generated_by_user = res.data[0].max_idea_generated_by_user;
          // this.max_idea_generated_by_document_type_name = res.data[0].max_idea_generated_by_document_type_name;
          // this.ideathon_winnerfor_month = res.data[0].ideathon_winnerfor_month;
          res.data.forEach(element => {
            this.max_idealist.push({ name: element.name, values: element.values });

          });

        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this._commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        this._commonService.showMessageBox(error.toString());
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    //  err => {
    //   this._commonService.showMessageBox(err.toString());
    // });
    // }).catch(err => {
    // });




  }




  getAuthorizedData_new_design() {
    this.authService.getAuthorizedData().subscribe(data => {
      debugger;
      if (data != null) {
        this.masterData = data;
        this.parent_masterData = data;
        this.project_masterData = [];

        data.forEach(item => {
          debugger;
            if (!this.project_masterData.find(x => x.project_id == item.project_id)) {
              ////this.project_masterData.push({ project_name: item.project_name, project_id: item.project_id });
              if (this._commonService.selectedProject == item.project_id) {
                debugger;
                this.onSelectProject_new_design({ project_name: item.project_name, project_id: item.project_id, parentId: 0 });
                this.project_masterData.push({ project_name: item.project_name, project_id: item.project_id, isbool: true });
                // this._commonService.setUserInfoToLocalStorage('roleId', item.roleId);
                // this._commonService.setUserInfoToLocalStorage('projectId', item.project_id);
              }
              else {
                this.project_masterData.push({ project_name: item.project_name, project_id: item.project_id, isbool: false });
              }
            }
          

        });
        this.isPageLoadCompleted = true;
      }
      else {
        alert("Records not found")
      }
    });
  }

  isSelected(parent: string, id: any) {
    if (parent == 'project') {
      if (this._commonService.selectedProject == id) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      if (this._commonService.selectedRole == id) {
        return true;
      }
      else {
        return false;
      }
    }


  }
  bindRoles_new_design(parent: string, node: any) {
    if (this.isPageLoadCompleted) {
      // this._commonService.setUserInfoToLocalStorage('roleId', 0);
      this.memorystore.setItem('roleId', 0);
    }
    this.roleList = [];
    if (parent == 'project') {
      this.masterData.filter(data => data.project_id == node.project_id).forEach(element => {
        if (element.assignedrole == 1) {// added by imran 04032026
          if (!this.roleList.find(x => x.roleId == element.role_id)) {
            //this.roleList.push({ roleId: element.role_id, roleName: element.role_name });
            if (this._commonService.selectedRole == element.role_id) {
              this.roleList.push({ roleId: element.role_id, roleName: element.role_name, isbool: true });
            }
            else {
              this.roleList.push({ roleId: element.role_id, roleName: element.role_name, isbool: false });
            }
          }
        }
      });
    }
    else if (parent == 'subgroup') {
      // this._commonService.setUserInfoToLocalStorage('subgroupId', node.Id);
      this.memorystore.setItem('subgroupId', node.Id);
 
      this.masterData.filter(data => data.subgroup_id == node.project_id).forEach(element => {
        if (!this.roleList.find(x => x.roleId == element.role_id)) {
          this.roleList.push({ roleId: element.role_id, roleName: element.role_name });
        }
      });
    }
  }

  roleselection_set_Is_initiator(node: any) {
    let params = new HttpParams();
    // params = params.append('project_id', this._commonService.selectedProject);
    // params = params.append('subgroup_id', this._commonService.selectedSubgroup);
    // params = params.append('role_id', this._commonService.selectedRole);
    // // params = params.append('userId', this._commonService.getUserInfoFromLocalStorage('userId'));
    // params = params.append('userId', this.memorystore.getItem('userId'));
    let bodydata = {
      roleid: this.encryptDecryptservice.encryptUsingAES256(this._commonService.selectedRole),
      subgroupid: this.encryptDecryptservice.encryptUsingAES256(this._commonService.selectedSubgroup),
      projectid: this.encryptDecryptservice.encryptUsingAES256(this._commonService.selectedProject),
      encuserid: this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    };
    //changed getData to postData
    // this.dataService.getData('isinitiator', params).subscribe(res => {
    this.dataService.postData('isinitiator', bodydata).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          // this._commonService.setUserInfoToLocalStorage('is_initiator', res.data[0].is_initiator);
          // this._commonService.setUserInfoToLocalStorage('is_implementation', res.data[0].is_implementation);
          this.memorystore.setItem('is_initiator', res.data[0].is_initiator);
          this.memorystore.setItem('is_implementation', res.data[0].is_implementation);
          EmmiterService.get("userInfo").emit();
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this._commonService.showMessageBox("Internal error")
        }
      }

    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      }
    );
  }


  onSelectRole_new_design(role: any) {
    debugger;
    let objProject = this.masterData.filter(data => data.project_id == this._commonService.selectedProject);
    // this._commonService.setUserInfoToLocalStorage('projectName', objProject[0].project_name);
    // this._commonService.setUserInfoToLocalStorage('roleId', role.roleId);
    this.memorystore.setItem('projectName', objProject[0].project_name);
    this.memorystore.setItem('roleId', role.roleId);
    this.exitingRole_id = role.roleId;
    this.roleselection_set_Is_initiator(role);
    //this._commonService.setUserInfoToLocalStorage('is_initiator', role.roleName);

    this.project_name = objProject[0].project_name;

    let objSubgroup = objProject.filter(data => data.subgroup_id == this._commonService.selectedSubgroup);

    if (objSubgroup.length > 0) {
      // this._commonService.setUserInfoToLocalStorage('subgroupName', objSubgroup[0].subgroup_name);
      this.memorystore.setItem('subgroupName', objSubgroup[0].subgroup_name);
    }
    else {
      // this._commonService.setUserInfoToLocalStorage('subgroupName', '');
      this.memorystore.setItem('subgroupName', '');
    }

    if (objProject.filter(x => x.role_id == role.roleId).length > 0) {
      // this._commonService.setUserInfoToLocalStorage('roleName', objProject.filter(x => x.role_id == role.roleId)[0].role_name);
      this.memorystore.setItem('roleName', objProject.filter(x => x.role_id == role.roleId)[0].role_name);
      this.role_name = objProject.filter(x => x.role_id == role.roleId)[0].role_name;
    }
    // let body = {
    //   project_id: this._commonService.selectedProject,
    //   subgroup_id: this._commonService.selectedSubgroup == 'null' ? '' : this._commonService.selectedSubgroup.toString(),
    //   role_id: roleId.toString(),
    //   user_id: this._commonService.getUserInfoFromLocalStorage('userId')
    // };

    // this.dataService.postData("user-persona", body).subscribe(res => {
    //   if (res != null && res.status == true) {
    //     this._commonService.setUserInfoToLocalStorage('isManagerialRole', res.data[0].is_managerial_role);
    //   }
    //   this._commonService.setUserInfoToLocalStorage('dash_docTypeId', '');
    //   this._commonService.setUserInfoToLocalStorage('dash_processId', '');
    //   this._commonService.setUserInfoToLocalStorage('dashbordGridAdvanceSearchField', '');
    //   this._commonService.setUserInfoToLocalStorage('dashbordSelectedWorklist', '');

    //   let dashboard_filters = this._commonService.getUserInfoFromLocalStorage('dashboard_filters');
    //   if (dashboard_filters != '' && dashboard_filters != undefined) {
    //     dashboard_filters = JSON.parse(dashboard_filters);
    //     let index = dashboard_filters.findIndex(f => f.project_id == this._commonService.getUserInfoFromLocalStorage('projectId'));
    //     if (index != undefined && index > 0) {
    //       dashboard_filters[index] = '';
    //     }
    //     this._commonService.setUserInfoToLocalStorage('dashboard_filters', JSON.stringify(dashboard_filters));
    //   }
    //   else {
    //     this._commonService.setUserInfoToLocalStorage('dashboard_filters', '');
    //   }

    //   if (this._commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0)
    //     this.router.navigate(['/dashboard']);
    //   else
    //     this.router.navigate(['/work-item']);      

    // });



    this.getHeaderLogoImagePath();

  }
  onSelectProject_new_design(node: any) {

    debugger;
    this.roleList = [];
    this.subGroupDataSource.data = [];
    this.project_name = node.project_name;
    this.role_name = "";
    // this._commonService.setUserInfoToLocalStorage('projectId', node.project_id);
    this.memorystore.setItem('projectId', node.project_id);
    debugger;
    let objSubgroup = this.masterData.filter(data => data.project_id == node.project_id && data.subgroup_id != null && data.subgroup_id != 0);
    if (objSubgroup.length > 0) {
      this.hasProjectHierarchy = true;
      this.bindSubgroupNodes(objSubgroup);
    } else {
      // this._commonService.setUserInfoToLocalStorage('subgroupId', 0);
      this.memorystore.setItem('subgroupId', 0);
      this.hasProjectHierarchy = false;
    }
    debugger;
    let objRole = this.masterData.filter(data => data.project_id == node.project_id && (data.subgroup_id == null || data.subgroup_id == 0));
    if (objRole.length > 0)
      this.bindRoles_new_design('project', node);

  }
  onProceed_new_design() {
    debugger;
    let body = {
      project_id: this._commonService.selectedProject,
      subgroup_id: this._commonService.selectedSubgroup == 'null' ? '' : this._commonService.selectedSubgroup.toString(),
      role_id: this._commonService.selectedRole,
      // user_id: this._commonService.getUserInfoFromLocalStorage('userId')
      user_id: this.memorystore.getItem('userId')
    };
    // this._commonService.setUserInfoToLocalStorage('dash_docTypeId', '');
    // this._commonService.setUserInfoToLocalStorage('dash_processId', '');
    // this._commonService.setUserInfoToLocalStorage('dashbordGridAdvanceSearchField', '');
    // this._commonService.setUserInfoToLocalStorage('dashbordSelectedWorklist', '');
    this.memorystore.setItem('dash_docTypeId', '');
    this.memorystore.setItem('dash_processId', '');
    this.memorystore.setItem('dashbordGridAdvanceSearchField', '');
    this.memorystore.setItem('dashbordSelectedWorklist', '');
    debugger;
    // let dashboard_filters = this._commonService.getUserInfoFromLocalStorage('dashboard_filters');
    let dashboard_filters = this.memorystore.getItem('dashboard_filters');
    if (dashboard_filters != '' && dashboard_filters != undefined) {
      dashboard_filters = JSON.parse(dashboard_filters);
      // let index = dashboard_filters.findIndex(f => f.project_id == this._commonService.getUserInfoFromLocalStorage('projectId'));
      let index = dashboard_filters.findIndex(f => f.project_id == this.memorystore.getItem('projectId'));
      if (index != undefined && index > 0) {
        dashboard_filters[index] = '';
      }
      // this._commonService.setUserInfoToLocalStorage('dashboard_filters', JSON.stringify(dashboard_filters));
      this.memorystore.setItem('dashboard_filters', JSON.stringify(dashboard_filters));

    }
    else {
      // this._commonService.setUserInfoToLocalStorage('dashboard_filters', '');
      this.memorystore.setItem('dashboard_filters', '');
    }

    // if (this._commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0)
    if (this.memorystore.getItem('isManagerialRole') == 0)
      this.router.navigate(['/control-panel']);
    else
      this.router.navigate(['/work-item']);
    debugger;
    // this.dataService.postData("user-persona", body).subscribe(res => {
    //   if (res != null && (res.error_message == null || res.error_message == "")) {
    //     if (res != null && res.status == true) {
    //       this._commonService.setUserInfoToLocalStorage('isManagerialRole', res.data[0].is_managerial_role);
    //     }
    //   }
    //   else {
    //     if (res.errorCode != 0 && res.errorCode == 4000) {
    //       this.router.navigateByUrl('/unauthorized');
    //       return;
    //     }
    //     if (res.errorCode != 0 && res.errorCode == 3000) {
    //       this._commonService.showMessageBox("Internal error")
    //     }
    //   }      

    // });



    this.getHeaderLogoImagePath();

  }


  getAuthorizedData() {
    this.authService.getAuthorizedData().subscribe(data => {
      debugger;
      if (data != null) {
        this.masterData = data;
        this.parent_masterData = data;
        const groupProjTreeData: FoodNodeFlat[] = [];
        // data.forEach(item => {
        //   if (!groupProjTreeData.find(x => x.Id == item.group_id))
        //     groupProjTreeData.push({ name: item.group_name, Id: item.group_id, parentId: 0, children: [] });
        // });

        // groupProjTreeData.forEach(item => {
        //   data.forEach(element => {
        //     if (!item.children.find(x => x.Id == element.project_id) && element.group_id == item.Id) {

        //       item.children.push({ name: element.project_name, Id: element.project_id, parentId: item.Id });

        //       if (this._commonService.selectedProject == element.project_id) {
        //         this.onSelectProject({ name: element.project_name, Id: element.project_id, parentId: item.Id });
        //       }
        //     }
        //   });
        // });   
        data.forEach(item => {
          if (!groupProjTreeData.find(x => x.Id == item.project_id)) {
            groupProjTreeData.push({ name: item.project_name, Id: item.project_id, parentId: 0, children: [] });
            if (this._commonService.selectedProject == item.project_id) {
              this.onSelectProject({ name: item.project_name, Id: item.project_id, parentId: 0 });
            }
          }

        });

        this.isPageLoadCompleted = true;
        this.groupProjectDataSource.data = groupProjTreeData;
        this.groupProjectTree.treeControl.expandAll();
      }
      else {
        alert("Records not found")
      }
    });
  }
  onSelectProject(node: any) {

    this.roleList = [];
    const subGroupTreeData: FoodNodeFlat[] = [];
    this.subGroupDataSource.data = subGroupTreeData;

    // this._commonService.setUserInfoToLocalStorage('projectId', node.Id);
    this.memorystore.setItem('projectId', node.Id);
    let objSubgroup = this.masterData.filter(data => data.project_id == node.Id && data.subgroup_id != null && data.subgroup_id != 0);
    if (objSubgroup.length > 0) {
      this.hasProjectHierarchy = true;
      this.bindSubgroupNodes(objSubgroup);
    } else {
      // this._commonService.setUserInfoToLocalStorage('subgroupId', 0);
      this.memorystore.setItem('subgroupId', 0);

      this.hasProjectHierarchy = false;
    }

    let objRole = this.masterData.filter(data => data.project_id == node.Id && (data.subgroup_id == null || data.subgroup_id == 0));
    if (objRole.length > 0)
      this.bindRoles('project', node);


  }

  bindSubgroupNodes(subgroups: any) {

    const subGroupTreeData: FoodNodeFlat[] = [];
    const distinctSubgroups = [];

    subgroups.forEach(item => {
      if (!distinctSubgroups.find(x => x.Id == item.subgroup_id)) {
        distinctSubgroups.push({ Id: item.subgroup_id, name: item.subgroup_name, parentId: item.parent_subgroup_id });
      }
    });

    distinctSubgroups.filter(data => data.parentId == null || data.parentId == 0).forEach(item => {
      subGroupTreeData.push(item);
    });
    subGroupTreeData.forEach(item => {
      this.createNestedArray(distinctSubgroups, item);
    });

    this.subGroupDataSource.data = subGroupTreeData;
    this.subGroupTree.treeControl.expandAll();

    this.bindRoles('subgroup', { Id: this._commonService.selectedSubgroup });
  }

  bindRoles(parent: string, node: any) {
    if (this.isPageLoadCompleted) {
      // this._commonService.setUserInfoToLocalStorage('roleId', 0);
      this.memorystore.setItem('roleId', 0);
    }
    this.roleList = [];
    if (parent == 'project') {
      this.masterData.filter(data => data.project_id == node.Id).forEach(element => {
        if (!this.roleList.find(x => x.Id == element.role_id)) {
          this.roleList.push({ roleId: element.role_id, roleName: element.role_name });
        }
      });
    }
    else if (parent == 'subgroup') {
      // this._commonService.setUserInfoToLocalStorage('subgroupId', node.Id);
      this.memorystore.setItem('subgroupId', node.Id);
      this.masterData.filter(data => data.subgroup_id == node.Id).forEach(element => {
        if (!this.roleList.find(x => x.Id == element.role_id)) {
          this.roleList.push({ roleId: element.role_id, roleName: element.role_name });
        }
      });
    }
  }

  onSelectRole(roleId: any) {

    let objProject = this.masterData.filter(data => data.project_id == this._commonService.selectedProject);
    // this._commonService.setUserInfoToLocalStorage('projectName', objProject[0].project_name);
    // this._commonService.setUserInfoToLocalStorage('roleId', roleId);
    this.memorystore.setItem('projectName', objProject[0].project_name);
    this.memorystore.setItem('roleId', roleId);
    let objSubgroup = objProject.filter(data => data.subgroup_id == this._commonService.selectedSubgroup);

    if (objSubgroup.length > 0) {
      // this._commonService.setUserInfoToLocalStorage('subgroupName', objSubgroup[0].subgroup_name);
      this.memorystore.setItem('subgroupName', objSubgroup[0].subgroup_name);
    }

    if (objProject.filter(x => x.role_id == roleId).length > 0)
      // this._commonService.setUserInfoToLocalStorage('roleName', objProject.filter(x => x.role_id == roleId)[0].role_name);
      this.memorystore.setItem('roleName', objProject.filter(x => x.role_id == roleId)[0].role_name);
    let body = {
      project_id: this._commonService.selectedProject,
      subgroup_id: this._commonService.selectedSubgroup == 'null' ? '' : this._commonService.selectedSubgroup.toString(),
      role_id: roleId.toString(),
      // user_id: this._commonService.getUserInfoFromLocalStorage('userId')
      user_id: this.memorystore.getItem('userId')
    };
    // this._commonService.setUserInfoToLocalStorage('dash_docTypeId', '');
    //   this._commonService.setUserInfoToLocalStorage('dash_processId', '');
    //   this._commonService.setUserInfoToLocalStorage('dashbordGridAdvanceSearchField', '');
    //   this._commonService.setUserInfoToLocalStorage('dashbordSelectedWorklist', '');
    this.memorystore.setItem('dash_docTypeId', '');
    this.memorystore.setItem('dash_processId', '');
    this.memorystore.setItem('dashbordGridAdvanceSearchField', '');
    this.memorystore.setItem('dashbordSelectedWorklist', '');
    // let dashboard_filters = this._commonService.getUserInfoFromLocalStorage('dashboard_filters');
    let dashboard_filters = this.memorystore.getItem('dashboard_filters');
    if (dashboard_filters != '' && dashboard_filters != undefined) {
      dashboard_filters = JSON.parse(dashboard_filters);
      // let index = dashboard_filters.findIndex(f => f.project_id == this._commonService.getUserInfoFromLocalStorage('projectId'));
      let index = dashboard_filters.findIndex(f => f.project_id == this.memorystore.getItem('projectId'));
      if (index != undefined && index > 0) {
        dashboard_filters[index] = '';
      }
      // this._commonService.setUserInfoToLocalStorage('dashboard_filters', JSON.stringify(dashboard_filters));
      this.memorystore.setItem('dashboard_filters', JSON.stringify(dashboard_filters));
    }
    else {
      // this._commonService.setUserInfoToLocalStorage('dashboard_filters', '');
      this.memorystore.setItem('dashboard_filters', '');
    }

    // if (this._commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0)
    if (this.memorystore.getItem('isManagerialRole') == 0)
      this.router.navigate(['/control-panel']);
    else
      this.router.navigate(['/work-item']);

    // this.dataService.postData("user-persona", body).subscribe(res => {
    // if (res != null && (res.error_message == null || res.error_message == "")) {
    //   if (res != null && res.status == true) {
    //     this._commonService.setUserInfoToLocalStorage('isManagerialRole', res.data[0].is_managerial_role);
    //   }
    // }
    // else {
    //   if (res.errorCode != 0 && res.errorCode == 4000) {
    //     this.router.navigateByUrl('/unauthorized');
    //     return;
    //   }
    //   if (res.errorCode != 0 && res.errorCode == 3000) {
    //     this._commonService.showMessageBox("Internal error")
    //   }
    // }      

    // });



    this.getHeaderLogoImagePath();
    //EmmiterService.get("userInfo").emit();

  }

  getHeaderLogoImagePath() {

    let params = new HttpParams();
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this._commonService.selectedProject));
    this.dataService.getData('header_logo_Image_Path', params).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          // this._commonService.setUserInfoToLocalStorage('HeaderLogo', res.data[0].header_logo_image_path);
          this.memorystore.setItem('HeaderLogo', res.data[0].header_logo_image_path);
          EmmiterService.get("userInfo").emit();
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this._commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        this._commonService.showMessageBox(error.toString());
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      }
    );

  }



  private createNestedArray(data: any, obj: any) {
    data.filter(x => x.parentId == obj.Id).forEach(element => {
      if (obj.children == undefined) obj.children = [];
      obj.children.push(element);
      if (data.filter(child => child.parentId == element.Id).length > 0) this.createNestedArray(data, element);
    });
  }

  getQueryStyle(i: any) {

    if (i == 1) {
      return { 'font-weight': 600 };
    }
    else if (i == 2) {
      return { 'font-weight': 600 };
    }
    else {
      return { 'font-weight': 600 };
    }


  }

}
